import React, { useState, useEffect } from 'react';
import Typography from '@mui/material/Typography';
import Stack from '@mui/material/Stack';
import Button from '@mui/material/Button';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import TextField from '@mui/material/TextField';
import { GoogleOAuthProvider, GoogleLogin } from '@react-oauth/google';
import axios from 'axios';
import Config from '../Config.json'
import Cookies from 'js-cookie';
import Snackbar from '@mui/material/Snackbar';

function SignupLogin(props) {
    
    // 0 = login, 1 = signup
    const [sOrL, setSOrL] = useState(props.signUpOrLogin === undefined ? 0 : props.signUpOrLogin);
    const [username, setUsername] = useState("");
    const [password, setPassword] = useState("");
    const [confirmPassword, setConfirmPassword] = useState("");
    const [errorMessage, setErrorMessage] = useState("");

    const handleLogin = (loginData) => {
        // console.log(loginData);
        //send google token to backend; on success, set cookies/redux? to logged in, rerender.
        axios.post(Config.urlStub + "/usernameLogin", loginData, {withCredentials: true}).then((response) => {
        // axios.post( Config.loginUrl, loginData, {withCredentials: true}).then((response) => {
        //   console.log(response.data.session_id); //profilePicLink
        //   console.log(response)
          //set cookies. browser will do this automatically via setCookies header?
          // const cookies = new Cookies(null, { path: '/' });
          Cookies.set('session_id', response.data.session_id);
        //   console.log('cookie s_id is', Cookies.get('session_id'));
          props.getProfileDisplay();
          props.closeDialog();
        }).catch(function (error) {
          //show problem with login
          console.log(error);
          setErrorMessage(error.response.data);
        })
      }

      const handleGoogleLogin = (loginData) => {
        // console.log(loginData);
        //send google token to backend; on success, set cookies/redux? to logged in, rerender.
        axios.post(Config.urlStub + "/login", loginData, {withCredentials: true}).then((response) => {
        // axios.post( Config.loginUrl, loginData, {withCredentials: true}).then((response) => {
        //   console.log(response.data.session_id); //profilePicLink
        //   console.log(response)
          //set cookies. browser will do this automatically via setCookies header?
          // const cookies = new Cookies(null, { path: '/' });
          Cookies.set('session_id', response.data.session_id);
        //   console.log('cookie s_id is', Cookies.get('session_id'));
          props.getProfileDisplay();
          props.closeDialog();
        }).catch(function (error) {
          //show problem with login
          console.log(error);
          setErrorMessage(error.response.data);
        })
      }
      

    const handleSignUp = (signupData) => {
        axios.post(Config.urlStub + "/usernameSignup", signupData, {withCredentials: true}).then((response) => {
        //   console.log(response.data.session_id); //profilePicLink
        //   console.log(response)
          //set cookies. browser will do this automatically via setCookies header?
          // const cookies = new Cookies(null, { path: '/' });
        //  Cookies.set('session_id', response.data.session_id);
        //   console.log('cookie s_id is', Cookies.get('session_id'));
          props.getProfileDisplay();
          props.closeDialog();
        }).catch(function (error) {
          //show problem with login
          console.log(error);
          // console.log("setting errormessage to:", error.message)
          setErrorMessage(error.response.data);
        })
    }

    function handleDialogAction() {
        // console.log("logging in")
        if (sOrL === 1) {
            if (confirmPassword != password) {
              setErrorMessage("Passwords are not equal");
              return;
            }
            handleSignUp({"username":username, "password":password});
        } else {
            // console.log("logging in")
            handleLogin({"username":username, "password":password});
        }
    }

    function onKeyPressed(key) {
      // window.alert('yeet')
      if (key.code == "Enter" || key.code == 'NumpadEnter') {
        handleDialogAction();
      }
    }

    return (
        <GoogleOAuthProvider clientId={Config.oAuthClientId}>
                <Card sx={{ width:'100%', minWidth:300 }} onKeyDown={onKeyPressed} >
                    <CardContent>
                        <Typography variant="h5" sx={{mb:1}}>
                            {sOrL === 1 ? "Sign Up":"Login"}
                        </Typography>
                        <Stack sx={{alignItems:"center"}} spacing={1}>
                        

                        <TextField onChange={(e) => setUsername(e.target.value)} 
                        autoComplete='off' inputProps={{ maxLength: 40 }} variant="filled" 
                        label="Username" value={username} sx={{width:'100%'}}/>

                        <TextField onChange={(e) => setPassword(e.target.value)} 
                        autoComplete='off' inputProps={{ maxLength: 40 }} variant="filled" 
                        type="password" label="Password" sx={{width:'100%'}} value={password}/>

                        {sOrL === 1 &&
                            <TextField onChange={(e) => setConfirmPassword(e.target.value)} 
                            autoComplete='off' inputProps={{ maxLength: 40 }} variant="filled" 
                        type="password" label="Confirm Password" sx={{width:'100%'}}  value={confirmPassword}/>
                        }

                        {errorMessage != "" && 
                          <Typography sx={{fontSize:'small', color:'red'}}>
                            {errorMessage}
                          </Typography>
                        }

                        <Button variant="contained" sx={{width:'100%', }} 
                        onClick={() => handleDialogAction()}>{sOrL === 1 ? "Sign Up":"Login"}</Button>
                        

                        <Typography color={"text.secondary"} sx={{mt:1}}>
                            sign in directly with Google below
                        </Typography>

                        <GoogleLogin
                            sx={{ width:'100%' }}
                            onSuccess={credentialResponse => {
                                handleGoogleLogin(credentialResponse);
                            }}
                            onError={() => {
                                console.log('Login Failed');
                            }}
                        />
                        
                        {sOrL === 0 &&
                            <Typography variant="body1">
                                Don't have an account? <Button onClick={() => setSOrL(1)}>Sign up</Button>
                            </Typography>
                        }

                        {sOrL === 1 &&
                            <Typography variant="body1">
                                Have an account already? <Button onClick={() => setSOrL(0)}>Login</Button>
                            </Typography>
                        }
                        </Stack>
                    </CardContent>
                </Card>
            </GoogleOAuthProvider>
    );
}

export default SignupLogin;